module.exports = __webpack_public_path__ + "img/partner2.ec681e39.png";